import { render, staticRenderFns } from "./FormataReal.vue?vue&type=template&id=4d00b4e6"
import script from "./FormataReal.vue?vue&type=script&lang=js"
export * from "./FormataReal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports